import React, { Component } from 'react'

import "./Toolbar.css";
import { Button, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';


class ToolbarPlatformDashboard extends Component {

    render() {
        return (
            <div className="toolBar" style={{ width:'100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}> 
                <div></div>                
            </div>
        )
    }
}

export default ToolbarPlatformDashboard

